// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2DVJb","title":"Images90_title__3dBQG","images":"Images90_images__3zS4z"};